export default {
  rolePos: {
    ROLE_IT: 'Administrador de Instituições',
    ROLE_AGENT: 'Administrador de Agentes',
  },
  booleanOptions: {
    YES: 'Sim',
    NO: 'Não',
  },
};
